module.exports = __webpack_public_path__ + "img/153.6045e46a.jpg";